export function QuestIcon({ src, className }: { src: string; className?: string }) {
  return <img className={className} src={src} alt="" width={64} height={64} decoding="async" draggable={false} />;
}
